const pdfCreateFromatter = (data) => {
  const dataSet = data.data || data;
  dataSet["status"] = "ERROR";
  return dataSet;
};

export default pdfCreateFromatter;
